import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {take} from 'rxjs/operators';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class ArchiveCaseCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public commandService: CommandService,
               public router: Router,
               private dialogService: DialogService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService, ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (command.fieldValues['IsClosed']) {

      const dialogModel = DialogModel.create('Archive Case',
        'AuditCaseArchiveDialogComponent',
        {},
        '600px', '700px',
        false);
      dialogModel.okCaption = 'Archive';
      this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
        if (res.action === 'OK') {
          if (res.data.input['comment'] && res.data.input['comment'].length > 0) {
            command.fieldValues['ArchivedComment'] = res.data.input['comment'];
          }

          this.executeCommandToApi(command, handler);
        }
      });

    } else {
      // show a dialog message
      this.dialogService.showDialogMessage('Message', 'Please make sure you mark the selected case as \'Closed\' before archiving.');
    }

    return true;
  }
}
